// import { NavLinkGroupDropdown } from "../components/NavLinkGroupDropdown"
import { Show, createEffect, lazy } from "solid-js";
import { useHeroForm } from "../contexts/HeroFormContext"
import { ColorOptionsContainer } from "./ColorOptionsContainer"
import { HeroAnchorContainer, HeroDescription, HeroMainInfo, HeroPolicyBullets, HeroSideNote, HeroSummaryPoints, PaymentSymbols } from "./HeroStaticComponents";
import { FixedProductCTA } from "../components/FixedProductCTA";
import { AlsoAvailableDropdowns } from "../components/AlsoAvailableDropdown";
import ProductHeroFormFields from "./ProductHeroFormFields";
import { DescriptionList } from "./DescriptionList";
import { ColorSelector } from "../components/ColorSelector";

// const ProductHeroFormFields = lazy(() => import('./ProductHeroFormFields'))


const HeroDetailsTop = (props) => {
  const {
    getters: {
      getExperimentFlags,
      isExperimentEnabled
    },
    heroSectionSettings
  } = useHeroForm();

  return (
    <div
      class="flex flex-col items-start"
    >
      <div
        class="flex flex-col justify-center items-center w-full"
        classList={{
          "sm:order-last w-full": heroSectionSettings.isNewVersion,
          "order-first sm:landscape:order-last": !heroSectionSettings.isNewVersion
        }}
      >
        <ColorOptionsContainer
          context={useHeroForm}
          {...(
            heroSectionSettings.isNewVersion
              ? {
                class: "sm:py-2 border-b-outer sm:border-t-outer sm:border-b-0",
                labelClass: "sm:px-6",
                // colorClass: "sm:first:ml-6"
              }
              : {}
          )}
        />
      </div>

      <div
        class="w-full sm:landscape:border-t-0 border-frame py-2 sm:py-2 px-2 sm:px-6"
        classList={{
          "border-t-0": heroSectionSettings.isNewVersion,
          "border-t-outer sm:py-3": !heroSectionSettings.isNewVersion
        }}
      >
        <HeroMainInfo {...props.productInfo} productInfo={productInfo} context={useHeroForm} />

        <div class=" flex-col gap-2 hidden">
          <HeroPolicyBullets
            policyBullets={heroSectionSettings['blocks']['policyBullets']}
            bulletColumns={heroSectionSettings['bulletColumns']}
          />
        </div>
      </div>
    </div>
  )
}

const HeroDetailsBottom = () => {
  const {
    getters: { getExperimentFlags, isExperimentEnabled },
  } = useHeroForm();
  return (
    <div class=" border-t-outer border-frame" >
      {/* <Show when={getExperimentFlags('DISCOUNT_TRUST_POLICY') != 'test'}>
        <PolicyIcons />
      </Show> */}
      {/* <PaymentSymbols /> */}



      <HeroSummaryPoints
        summaryPoints={heroSectionSettings['blocks']['summaryPoints']}
      />

      <Show when={showDescription == true}>
        <HeroDescription
          description={heroSectionSettings['description']}
          lineClampLimit={heroSectionSettings['lineClampLimit']}
        />
      </Show>
      <Show when={showAnchor == true}>
        <HeroSideNote
          sideNote={heroSectionSettings['sideNote']}
        />
        <HeroAnchorContainer
          anchors={heroSectionSettings['blocks']['anchors']}
        />
      </Show>
      {/* <Show when={showRelatedProducts}>
        <AlsoAvailableDropdowns /> 
      </Show>  */}

    </div>
  )
}

export const HeroProductDetails = () => {

  const {
    productInfo,
    color: {
      color,
      handlers: {
        handleColorSelection
      }
    },
    getters: {
      getExperimentFlags,
      isExperimentEnabled
    },
    heroSectionSettings
  } = useHeroForm();

  return (
    <div
      class="sm:col-span-1 gap-2 sm:landscape:border-l-outer border-frame sm:ml-negative-outer w-full sm:overflow-scroll scrollbar-hide max-w-121 plsus2xl:border-r-outer"
    >
      <div
        id="description-block"
        class="GA-element-observer w-full"
        data-element-meta={`${template} / Product Hero Classic / Product Description`}
      >
        <HeroDetailsTop productInfo={productInfo} />
        <Show when={!heroSectionSettings.isNewVersion && productInfo.descriptions}>
          <DescriptionList
            class="px-2 pb-2 sm:px-6 text-sm sm:text-base my-1"
            descriptions={productInfo.descriptions}
            getters={{ getExperimentFlags, isExperimentEnabled }}
          />
        </Show>
        {/* <Show when={productInfo.subheadline2}>
          <p class="mt-1 mb-2 text-sm px-2 sm:px-6 font-bold">{productInfo.subheadline2}</p>
        </Show> */}
        <ProductHeroFormFields />
        <HeroDetailsBottom />
        <Show when={window.innerWidth >= 768}>
          <FixedProductCTA />
        </Show>
      </div>
    </div>
  )
}

const PolicyIcons = () => {
  return (<div class="grid grid-cols-3 divide-x-inner divide-frame border-b-inner border-frame w-full">
    <div className="flex flex-col items-center p-2 gap-1">
      <div><svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="M454.873-163.025v-302.719L190.256-618.77v295.795q0 3.077 1.539 5.77 1.539 2.692 4.616 4.616l258.462 149.564Zm50.254 0 258.462-149.564q3.078-1.924 4.616-4.616 1.539-2.693 1.539-5.77V-619.18L505.127-465.744v302.719Zm-56.409 54.229L171.283-268.822q-14.769-8.358-23.025-22.922-8.257-14.564-8.257-31.282v-313.948q0-16.718 8.257-31.282 8.256-14.564 23.025-22.922l277.435-160.026q14.769-8.358 31.282-8.358 16.513 0 31.282 8.358l277.435 160.026q14.769 8.358 23.025 22.922 8.257 14.564 8.257 31.282v313.948q0 16.718-8.257 31.282-8.256 14.564-23.025 22.922L511.282-108.796q-14.769 8.358-31.282 8.358-16.513 0-31.282-8.358Zm187.41-490.741 105.078-60.668-255.052-147.564q-3.077-1.667-6.154-1.667t-6.154 1.667l-98.488 56.77 260.77 151.462ZM480-508.512l105.719-61.693-261.616-151.026-105.719 61.026L480-508.512Z" /></svg></div>
      <div class="text-center text-xs sm:text-sm">Free Shippping</div>
    </div>
    <div className="flex flex-col items-center p-2 gap-1">
      <div><svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="M277.924-220.001v-50.255h299.795q66 0 113.051-44.526t47.051-109.757q0-64.974-47.051-109.308-47.051-44.333-113.051-44.333H275.896L392.076-462l-35.383 35.384-176.692-176.691 176.692-176.692 35.383 35.384-116.18 116.18h301.156q86.948 0 148.986 58.987t62.038 144.909q0 85.923-62.038 145.23Q664-220.001 577.052-220.001H277.924Z" /></svg></div>
      <div class="text-center text-xs sm:text-sm">Free 90 Day returns and remakes</div>
    </div>
    <div className="flex flex-col items-center p-2 gap-1">
      <div><svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="M301.582-537.052q-50.44 0-86.01-35.656-35.571-35.655-35.571-86.095t35.656-86.01q35.656-35.57 86.096-35.57 50.439 0 86.01 35.656 35.57 35.655 35.57 86.095t-35.656 86.01q-35.656 35.57-86.095 35.57Zm-.016-50.255q29.948 0 50.73-20.681 20.782-20.681 20.782-50.628 0-29.948-20.681-50.73-20.681-20.782-50.629-20.782-29.947 0-50.729 20.681-20.783 20.681-20.783 50.628 0 29.948 20.682 50.73 20.681 20.782 50.628 20.782Zm357.066 407.306q-50.44 0-86.01-35.656-35.57-35.656-35.57-86.096 0-50.439 35.656-86.01 35.655-35.57 86.095-35.57t86.01 35.656q35.57 35.656 35.57 86.095 0 50.44-35.656 86.01-35.655 35.571-86.095 35.571Zm-.016-50.255q29.948 0 50.73-20.682 20.782-20.681 20.782-50.628 0-29.948-20.681-50.73-20.681-20.782-50.628-20.782-29.948 0-50.73 20.681-20.782 20.681-20.782 50.629 0 29.947 20.681 50.729 20.681 20.783 50.628 20.783Zm-439.769 46.408-34.999-34.999 557.69-557.69 34.999 34.999-557.69 557.69Z" /></svg></div>
      <div class="text-center text-xs sm:text-sm">Inclusive of taxes</div>
    </div>
  </div>)
}